import "./userProfileStyle.css";
import { paths } from "../../paths/paths";

const CoverBar = ({ details }) => {
  if (details) {
    let img =
      "url('/assets/images/Group 8260.png') center center / cover no-repeat";

    return (
      <div
        className="w-100 cover-stickyClass"
        style={{
          background: img,
          opacity: 1,
          zIndex: 10,
        }}
      >
        <div
          className="py-4"
          style={{
            height: "inherit",
            backgroundColor: "rgba(26, 115, 232, 0.3)",
          }}
        >
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-center col-12 h-100">
            <div className="d-flex flex-column flex-md-row align-items-center col-md-9 col-12">
              <div
                style={{
                  backgroundColor: "white",
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                }}
              >
                {details?.photo ? (
                  <img
                    src={`${paths.MemberPhoto}${details.memberId}/${details.photo}`}
                    alt=""
                    height={120}
                    width={120}
                  />
                ) : (
                  <img
                    src="/assets/images/userPlaceholder.png"
                    height={120}
                    width={120}
                    alt=""
                  />
                )}
              </div>
              <div className="d-flex flex-column col">
                <div className="mx-4">
                  <p
                    className="text-white txt-align fw-bold mb-0"
                    style={{ fontSize: 22 }}
                  >
                    {String().concat(
                      details.titleName ?? "",
                      "  ",
                      details.name ?? ""
                    )}
                  </p>
                </div>
                <div className="mx-4">
                  <p
                    className="text-white txt-align mb-0"
                    style={{ fontSize: 14 }}
                  >
                    {details.professionalStatusName ?? ""}
                  </p>
                </div>
              </div>
            </div>
            {/* <div>
              <Button
                containerStyle={"col-sm-5 col-6 mt-md-0 mt-3"}
                // onClick={() => {
                // }}
                content={"تعديل الملف الشخصي"}
                image={
                  <img
                    src="/assets/images/greeniconedit.svg"
                    className="mb-1"
                    style={{ filter: "brightness(0) invert(1)" }}
                  />
                }
                customStyle={{
                  borderRadius: 10,
                  width: 200,
                  color: "white",
                  borderColor: "white",
                }}
              />
            </div> */}
          </div>
        </div>
      </div>
    );
  }
  return <div></div>;
};

export default CoverBar;
